<script lang="ts" setup>
import PaymentInlinePanelDefault from './PaymentInlinePanel.default.vue'
import PaymentInlinePanelNovelarc from './PaymentInlinePanel.novelarc.vue'
import { loadBrandComponent } from '@/utils/loadBrandConfig'

withDefaults(defineProps<{
  contentId: string
  contentChapterId: string
  bookName?: string
  chapterName?: string
  serialStatus?: number
  dark?: boolean
}>(), {
  bookName: '',
  chapterName: '',
  serialStatus: 0,
})

const emit = defineEmits<{
  (e: 'success'): void
  (e: 'update:membership-only', val: boolean): void
}>()

const PaymentInlinePanelComponent = loadBrandComponent({
  rocnovel: PaymentInlinePanelDefault,
  oceread: PaymentInlinePanelDefault,
  ficmoon: PaymentInlinePanelDefault,
  novelarc: PaymentInlinePanelNovelarc,
  storyella: PaymentInlinePanelNovelarc,
  silktale: PaymentInlinePanelNovelarc,
  pearla: PaymentInlinePanelNovelarc,
  fictora: PaymentInlinePanelDefault,
  marinovel: PaymentInlinePanelDefault,
})
</script>

<template>
  <PaymentInlinePanelComponent
    :content-id="contentId"
    :content-chapter-id="contentChapterId"
    :book-name="bookName"
    :chapter-name="chapterName"
    :serial-status="serialStatus"
    :dark="dark"
    @success="emit('success')"
    @update:membership-only="val => emit('update:membership-only', val)"
  />
</template>
